export default __webpack_public_path__ + "static/media/FAQ_1_1.f9a3e7b5.png";